
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class editMaterialNameAndGramsModal extends Vue {

    @Prop({
        default: () => new OM.CompanyMaterialConversionVM()
    }) model: OM.CompanyMaterialConversionVM;

    localModel: OM.RawMaterialCompanyConversionVM = new OM.RawMaterialCompanyConversionVM();

    @Prop() callback: (updateCompanyMaterialProperties: OM.RawMaterialCompanyConversionVM) => void;

    created() {
        // `identifier` on the VM is the CONVERSION ROW's id — which is what the server's
        // UpdateNameAndGramsForCompany takes as `configurationId`.
        this.localModel.configurationId = this.model.identifier;
        this.localModel.materialName = this.model.companyMaterialName;
        this.localModel.suggestedGramsPerSquareMeters = this.model.companySuggestedGramsPerSquareMeters;
    }

    get disabled() {
        return !this.localModel.materialName || !this.localModel.suggestedGramsPerSquareMeters;
    }

    save() {
        this.callback(this.localModel);
    }
    
}
